import React, { Component } from "react"
import { Content, Frame as FrameC } from "arwes"
import styled from "styled-components"
import { formatPostDate } from "../../common/util/dates"
import UserAvatar from "../../common/UserAvatar"

// Forum-style card: author rail on the left (square avatar, name,
// date), transmission content on the right.
const Row = styled.div`
  display: flex;
  gap: 16px;
  padding: 14px 15px;

  @media (max-width: 600px) {
    gap: 12px;
    padding: 12px;
  }

  @media (max-width: 300px) {
    gap: 8px;
    padding: 10px 8px;
  }
`

const AuthorRail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 96px;
  flex-shrink: 0;
  text-align: center;

  @media (max-width: 600px) {
    gap: 5px;
    width: 88px;

    img {
      width: 64px !important;
      height: 64px !important;
    }
  }

  @media (max-width: 300px) {
    width: 64px;

    img {
      width: 56px !important;
      height: 56px !important;
    }
  }
`

const AuthorName = styled.div`
  font-family: "VT323", monospace;
  font-size: 0.85rem;
  color: #00e7ff;
  word-break: break-word;
`

const PostDate = styled.div`
  font-family: "VT323", monospace;
  font-size: 0.75rem;
  color: #d1ffdb;
`

const MsgCount = styled.div`
  font-family: "VT323", monospace;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  color: #ffb800;
`

const Main = styled.div`
  flex: 1;
  min-width: 0;

  blockquote {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`

const Title = styled.div`
  padding: 0 10px 8px 0;
  overflow-wrap: anywhere;
  word-break: break-word;
`

class Post extends Component {
  state = {
    count: "success",
    corner: 1
  }
  mouseOver = () => {
    this.setState({
      count: "control",
      corner: 4
    })
  }
  mouseLeave = () => {
    this.setState({
      count: "success",
      corner: 1
    })
  }

  render() {
    const { post = {} } = this.props
    const displayDate = formatPostDate(post.created)

    const postBody = (post.body || "").substring(0, 100)

    return (
      <div style={{ marginBottom: "8px" }}>
        <FrameC
          onMouseOver={() => this.mouseOver()}
          onMouseLeave={this.mouseLeave}
          animate
          level={2}
          corners={this.state.corner}
          layer={this.state.count}
        >
          <Content node="div" key={post._id}>
            <Row>
              <AuthorRail>
                <UserAvatar user={post.postedBy} size={72} square />
                <AuthorName>
                  {post && post.postedBy ? post.postedBy.name : "deletedUser"}
                </AuthorName>
                {post.postedBy && post.postedBy.messageCount != null && (
                  <MsgCount>MSGS: {post.postedBy.messageCount}</MsgCount>
                )}
                <PostDate>{displayDate}</PostDate>
              </AuthorRail>
              <Main>
                <Title data-layer="disabled">{post.title}</Title>
                <blockquote data-layer="disabled">{postBody}</blockquote>
              </Main>
            </Row>
          </Content>
        </FrameC>
      </div>
    )
  }
}

export default Post
